<h2 mat-dialog-title>
  {{ "drft_vrsn_cnfrmtion_dlg.title" | translate }}
</h2>
<mat-dialog-content class="height-14">
  <mat-radio-group class="example-radio-group" [(ngModel)]="selectedOption">
    <mat-radio-button value="0" class="margin-10" [checked]="true">{{
      "drft_vrsn_cnfrmtion_dlg.create_with_curnt_cntnt" | translate
    }}</mat-radio-button>
    <mat-radio-button value="1">{{
      "drft_vrsn_cnfrmtion_dlg.create_with_orgnl_cntnt" | translate
    }}</mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions class="action-btn" align="end">
  <button
    color="primary"
    (click)="confrim()"
    style="margin-right: 5px"
    mat-raised-button
  >
    {{ "drft_vrsn_cnfrmtion_dlg.confirmation_btn" | translate }}
  </button>
  <button mat-flat-button (click)="cancel()">
    {{ "drft_vrsn_cnfrmtion_dlg.cancel_btn" | translate }}
  </button>
</mat-dialog-actions>
